import { ENV } from "@/core/config/env";
import routeTenant from "@/core/services/routeTenant.service"

const baseUrlTenant = routeTenant.routeBaseConfig();

const subcontractor = [
    {
        path: baseUrlTenant,
        name: "subcontractor",
        component: () => import("@/view/layout/Layout"),
        children: [
            {
                path: "subcontractor",
                name: "subcontractor",
                component: () => import("@/view/pages/subcontractor/List")
            },
            {
                path: "subcontractor-detail/:id",
                name: "subcontractor-detail",
                component: () => import("@/view/pages/subcontractor/Detail")
            },
            {
                path: "budget-report/:answer_id",
                name: "budget-report",
                component: () => import("@/view/pages/subcontractor/BudgetReport")
            },
            {
                path: "performance-report/:answer_id",
                name: "performance-report",
                component: () => import("@/view/pages/subcontractor/PerformanceReport")
            },
        ]
    },
]

export default subcontractor
